import React from 'react';
import ReactDOM from 'react-dom';
import { withCookies } from 'react-cookie';
import { DeleteOutlined, SnippetsOutlined } from '@ant-design/icons';
import { Spin, Checkbox } from 'antd';
import { ListView, Toast, Modal, SearchBar } from 'antd-mobile';
import { Link } from 'react-router-dom';
import moment from "moment";

import { _getDataFormList, _dropDataForm, _getHandleDataFormList, _getCCDataFormList, _getDataFormListByFrom, _getRelatedDataFormList, _copySubmitForm } from "../../server";
import { isIPhoneXSMax, isIphoneX, isIPhoneXR } from "../ShareUtils";
import styles from "./formlist.module.css";

const alert = Modal.alert;

const CheckboxGroup = Checkbox.Group;

let pageIndex = 0;
let pageSize = 10;

class MyListView extends React.Component {

    constructor(props) {
        super(props);
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);

        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1.formId !== row2.formId
        });

        const key = this.props.formStatus + "_" + this.props.status + "_" + this.props.listType;

        let searchKey = window.sessionStorage.getItem(key + "_searchKey");
        if (!searchKey) {
            searchKey = "";
        }
        let searchType = window.sessionStorage.getItem(key + "_searchType");
        if (!searchType) {
            searchType = [1];
        } else {
            searchType = JSON.parse(searchType);
        }

        this.state = {
            formStatus: this.props.formStatus, //表单状态
            status: this.props.status, //节点状态
            isLoading: true,
            listType: this.props.listType, //1=提交列表, 2=明细列表，3=待处理、已处理，4=抄送我，5=相关列表
            data: [],
            dataSource,
            isRefreshing: true,
            isShowSearchType: searchKey.length > 0,
            searchType: searchType,
            searchKey: searchKey,
            definitionId: this.props.definitionId,
        };
    }

    componentDidMount() {
        this.props.onRef(this);
        this.getList(this.state.formStatus, this.state.status, this.state.definitionId);
    }

    componentWillUnmount() {
        const key = this.state.formStatus + "_" + this.state.status + "_" + this.state.listType;
        window.sessionStorage.setItem(key + "_searchKey", this.state.searchKey);
        if (this.state.searchType.length > 0) {
            window.sessionStorage.setItem(key + "_searchType", JSON.stringify(this.state.searchType));
        }
    }

    onEndReached = (event) => {
        if (this.state.isLoading && !this.state.hasMore) {
            return;
        }
        this.setState({ isLoading: true });
        ++pageIndex;
        this.getList(this.state.formStatus, this.state.status, this.state.definitionId);
    }

    integrateData(newList) {
        if (!newList) {
            newList = [];
        }
        if (this.state.data && this.state.data.length > 0) {
            var list = [];
            for (var i = 0; i < newList.length; i++) {
                var has = false;
                for (var j = 0; j < this.state.data.length; j++) {
                    if (this.state.data[j].id === newList[i].id) {
                        has = true;
                        break;
                    }
                }
                if (!has) {
                    list.push(newList[i]);
                }
            }
            this.state.data = this.state.data.concat(list);
        } else {
            this.state.data = [].concat(newList);
        }
        this.setState({
            data: this.state.data,
            dataSource: this.state.dataSource.cloneWithRows(this.state.data),
        });
    }

    async getDataFormList(formStatus) {
        const res = await _getDataFormList(this.sid, formStatus, pageIndex, pageSize, this.state.searchType, this.state.searchKey);
        if (res.code === 0) {
            this.integrateData(res.data.list);
        }
        this.setState({ isLoading: false, isRefreshing: false });
    }

    async getHandleDataFormList(status) {
        const res = await _getHandleDataFormList(this.sid, status, pageIndex, pageSize, this.state.searchType, this.state.searchKey);
        if (res.code === 0) {
            this.integrateData(res.data.list);
        }
        this.setState({ isLoading: false, isRefreshing: false });
    }

    async getCCDataFormList(formStatus) {
        const res = await _getCCDataFormList(this.sid, formStatus, pageIndex, pageSize, this.state.searchType, this.state.searchKey);
        if (res.code === 0) {
            this.integrateData(res.data.list);
        }
        this.setState({ isLoading: false, isRefreshing: false });
    }

    async getRelatedDataFormList(formStatus) {
        const res = await _getRelatedDataFormList(this.sid, formStatus, pageIndex, pageSize, this.state.searchType, this.state.searchKey);
        if (res.code === 0) {
            this.integrateData(res.data.list);
        }
        this.setState({ isLoading: false, isRefreshing: false });
    }

    async getDataFormListByFrom(definitionId) {
        const res = await _getDataFormListByFrom(this.sid, definitionId, pageIndex, pageSize, this.state.searchType, this.state.searchKey);
        if (res.code === 0) {
            this.integrateData(res.data.list);
        }
        this.setState({ isLoading: false, isRefreshing: false });
    }

    searchList = (value) => {
        pageIndex = 0;
        this.setState({
            isLoading: false,
            isRefreshing: true,
            data: [],
            searchKey: value,
            dataSource: this.state.dataSource.cloneWithRows([])
        }, () => setTimeout(this.getList(this.state.formStatus, this.state.status, this.state.definitionId), 10));
    }

    refreshList = (formStatus, status, listType, definitionId) => {
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);
        pageIndex = 0;
        this.setState({
            isLoading: false,
            isRefreshing: true,
            data: [],
            formStatus: formStatus,
            status: status,
            listType: listType,
            definitionId: definitionId,
            isShowSearchType: this.state.searchKey.length > 0,
            dataSource: this.state.dataSource.cloneWithRows([])
        }, () => setTimeout(this.getList(formStatus, status, definitionId), 10));
    }

    getList = (formStatus, status, definitionId) => {
        if (this.state.data.length === 0) {
            pageIndex = 0;
        }
        switch (this.state.listType) {
            case 1:
                //我提交的
                this.getDataFormList(formStatus);
                break;
            case 2:
                //明细数据
                this.getDataFormListByFrom(definitionId);
                break;
            case 3:
                //待办理、已处理
                this.getHandleDataFormList(status);
                break;
            case 4:
                //抄送我
                this.getCCDataFormList(formStatus);
                break;
            case 5:
                //我相关的
                this.getRelatedDataFormList(formStatus);
                break;
            default:
                break;
        }
    }

    async dropDataForm(instanceTitle, formDataId) {
        const res = await _dropDataForm(this.sid, formDataId);
        if (res.code === 0) {
            this.getList(this.state.formStatus, this.state.status, this.state.definitionId);
        } else if (res.code === 3007) {
            alert('提示', '标题为【' + instanceTitle + '】的工单' + res.msg,
                [{
                    text: '确定',
                    onPress: () => {

                    }
                },]);
        } else {
            Toast.offline('网络错误，请稍后重试', 2);
        }
    }

    async copySubmitForm(formDataId) {
        const res = await _copySubmitForm(this.sid, formDataId);
        if (res.code === 0) {
            var oaNum = res.data.oaNum;
            if (oaNum) {
                window.location.href = `/formmain?formDataId=${oaNum}`;
            } else {
                Toast.offline('网络错误，请稍后重试', 2);
            }
        } else {
            Toast.offline('网络错误，请稍后重试', 2);
        }
    }

    deleteDataForm = (instanceTitle, formDataId) => {
        this.dropDataForm(instanceTitle, formDataId);
    }

    onCheckBoxChange = (checkedList) => {
        this.setState({ searchType: checkedList });
    }

    renderRow = (rowData, rowID) => {
        return (
            <Link key={rowID} to={{ pathname: '/formdetail', query: { formDataId: rowData.formDataId } }}>
                <div style={{ borderBottom: '1px solid #F6F6F6', padding: this.state.listType === 1 ? "15px 90px 15px 15px" : "15px 25px 15px 15px" }}
                    className={[`${styles.cardListItem}`, `${styles.flexbox}`].join(' ')}>
                    <div className={styles.flexItem}>
                        <div className={styles.listTitle}>
                            <h3>{rowData.instanceTitle}</h3>
                        </div>
                        <p className={styles.listInfo}>提单人 · {rowData.createUserName}  {moment(rowData.createTime).format('YYYY/MM/DD')}</p>
                        <p className={[`${styles.listStatus}`, rowData.status === 1 ? `${styles.formAudited}` : (rowData.status === 2 ? `${styles.formAudit}` : (rowData.status === 0 ? `${styles.formBack}` : ``))].join(' ')}>
                            {rowData.status === 1 ? "已审批" : (rowData.status === 2 ? "审批中 · " + rowData.currentFlowNode : (rowData.status === -1 ? "已关闭" : (rowData.status === 0 ? "退审" : (rowData.status === 99 ? "已关闭" : "默认"))))}
                        </p>
                    </div>
                    {
                        this.state.listType === 1 ?
                            <div>
                                <SnippetsOutlined
                                    className={styles.iconOperate} style={{ right: 50 }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.copySubmitForm(rowData.formDataId);
                                    }} />
                                <DeleteOutlined
                                    className={styles.iconOperate}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        alert('删除', '是否要删除该表单',
                                            [
                                                { text: '取消', onPress: () => console.log('cancel') },
                                                { text: '删除', onPress: () => this.deleteDataForm(rowData.instanceTitle, rowData.formDataId) },
                                            ])
                                    }} />
                            </div>
                            : <span></span>
                    }
                </div>
            </Link>
        );
    }

    render() {
        return <div id={"lv_wrap_" + this.state.listType} className={1 === this.state.listType || 5 === this.state.listType ? `${styles.my_listview_}` : 2 === this.state.listType ? `${styles.my_listview__}` : `${styles.my_listview}`}>
            <SearchBar placeholder="请输入关键词" maxLength={20} value={this.state.searchKey}
                ref={ref => this.manualFocusInst = ref}
                onChange={(value) => this.setState({ searchKey: value })}
                onFocus={() => { this.setState({ isShowSearchType: true }) }}
                onCancel={() => { this.setState({ isShowSearchType: false, searchKey: "" }); this.searchList(""); }}
                onClear={() => { this.setState({ isShowSearchType: false, searchKey: "" }); this.searchList(""); }}
                onSubmit={(value) => this.searchList(value)} />
            {
                !this.state.isShowSearchType ? "" :
                    <div style={{ width: '100%', height: 60, padding: 15, borderBottom: "1px solid rgb(246, 246, 246)" }}>
                        <CheckboxGroup onClick={() => { this.manualFocusInst.focus(); }}
                            value={this.state.searchType} onChange={e => this.onCheckBoxChange(e)}>
                            <Checkbox value={1} style={{ padding: "0 10px" }}>表单标题</Checkbox>
                            <Checkbox value={2} style={{ padding: "0 10px" }}>表单内容</Checkbox>
                            {
                                // <Checkbox value={3} style={{padding:"0 10px"}}>表单编号</Checkbox>
                                // this.state.listType!==1?<Checkbox value={4} style={{padding:"0 10px"}}>提单人</Checkbox>:""
                            }
                        </CheckboxGroup>
                    </div>
            }
            {
                this.state.isRefreshing ? <Spin style={{ width: "100%", marginTop: "40%" }} size="large" /> :
                    this.state.data.length === 0 ? <div className="empty"><div className="img"></div><p className="desc">暂无数据</p></div> :
                        <ListView
                            ref={el => this.lv = el}
                            dataSource={this.state.dataSource}
                            renderFooter={() => (<div style={{ textAlign: 'center' }}>{this.state.isLoading ? '加载中...' : '共' + this.state.data.length + '张表单'}</div>)}
                            renderRow={(rowData, sectionID, rowID) => this.renderRow(rowData, rowID)}
                            pageSize={pageSize}
                            style={{ height: '100%', overflow: 'auto' }}
                            scrollRenderAheadDistance={500}
                            onEndReached={this.onEndReached}
                            onEndReachedThreshold={10} />
            }
        </div>
            ;
    }

}

export default withCookies(MyListView);

